import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

export async function exportPdf(el, filename) {
  const canvas = await html2canvas(el, { scale: 2, backgroundColor: "#ffffff", useCORS: true });
  const pdf = new jsPDF("p", "mm", "a4");
  const w = pdf.internal.pageSize.getWidth() - 20;
  const pageH = pdf.internal.pageSize.getHeight() - 20;
  const imgH = (canvas.height * w) / canvas.width;
  const img = canvas.toDataURL("image/jpeg", 0.95);
  let offset = 0;
  while (offset < imgH) {
    if (offset > 0) pdf.addPage();
    pdf.addImage(img, "JPEG", 10, 10 - offset, w, imgH);
    offset += pageH;
  }
  pdf.save(filename);
}
